import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'


import Vstudio20Presets from './components/VStudio20Presets.vue'
registerVueComponentAndAngularBindings('vstudio20_presets:component', 'vstudio20Presets', Vstudio20Presets)